// extracted by mini-css-extract-plugin
export default {"img":"SalesSlick_img__Es6MP"};